import React, { useRef, useEffect } from "react";
import "./Hero.css";
import { ArrowRight } from "lucide-react";
import Estatua from "../assets/chaveiro1.webp";

const Hero = () => {
  const bustoRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY * 0.2;
      if (bustoRef.current) {
        bustoRef.current.style.transform = `translateY(${offset}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && bustoRef.current) {
          bustoRef.current.classList.add("animate", "loop");
        }
      },
      { threshold: 0.6 }
    );
    if (bustoRef.current) observer.observe(bustoRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="hero" className="hero-section">
      <div className="hero-content-wrapper">
        <div className="hero-left" data-aos="fade-in">
          <h1 className="hero-title">
            Por que tantos profissionais da saúde estão perdendo pacientes —
            mesmo com ótimos
            <span className="highlight"> resultados clínicos</span>?
          </h1>
          {/* <p className="hero-subtitle">
            Soluções estratégicas e personalizadas para transformar sua prática
            em um negócio de alta performance e reconhecimento.
          </p> */}
          <div className="hero-button-wrapper">
            <a href="#vsl" className="hero-button">
              Conheça a solução
              <ArrowRight className="arrow-icon" />
            </a>
          </div>
        </div>

        <div className="hero-right">
          <img
            ref={bustoRef}
            src={Estatua}
            alt="O Sussurro de Hermes"
            className="hero-busto"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
